/**
 * Dashboard Stats Hook
 * Reusable hook for fetching dashboard statistics
 */

import { useQuery } from '@tanstack/react-query';
import apiClient from '@/api/api.client';
import { API_ENDPOINTS } from '@/api/endpoints';
import type { DashboardStats, ApiResponse } from '@/api/types';

export const DASHBOARD_STATS_KEY = ['dashboard-stats'];

export function useDashboardStats(options?: { enabled?: boolean }) {
  return useQuery<ApiResponse<DashboardStats>, Error, DashboardStats>({
    queryKey: DASHBOARD_STATS_KEY,
    queryFn: async () => {
      const response = await apiClient.get<ApiResponse<DashboardStats>>(
        API_ENDPOINTS.STATS.DASHBOARD
      );
      return response.data;
    },
    select: (data) => data.data,
    staleTime: 30000,
    refetchInterval: 60000,
    retry: 2,
    enabled: options?.enabled ?? true,
  });
}

export default useDashboardStats;

